/*
  Garantie MINT — carte des ateliers + recherche par code postal.
  cf. sections/garantie-mint.liquid et assets/garantie-mint.css.

  CHARGEMENT PARESSEUX : MapLibre et les tuiles ne partent QU'A L'ENTREE du bloc dans le
  viewport (IntersectionObserver). Sur une visite qui ne descend pas, on ne paie rien.

  FOND DE CARTE : tuiles VECTORIELLES OpenFreeMap (donnees OpenStreetMap), rendues par
  MapLibre. Les noms de villes sont dessines par le navigateur : nets a toute densite
  d'ecran et a tout zoom, la ou le Plan IGN raster (textes figes en pixels) restait flou.
  Sans cle ni quota. Couleurs facon Google Maps posees dans le style au chargement
  (`paintBrand`), plus aucune recoloration pixel par pixel.

  ZOOM : MapLibre compte ses niveaux en tuiles de 512px, un de moins que Leaflet a
  echelle egale. Le reglage `map_zoom` et les seuils ci-dessous restent exprimes en
  niveaux « Leaflet » (ZOOM_OFFSET) pour ne pas changer le sens du reglage editeur.

  REPERES : `maplibregl.Marker` en forme de badge « M » MINT (voir `MARK_SVG_INNER`,
  `pinElement`), taille croissante avec le zoom (`pinSizeForZoom`).
  UN REPERE PAR ATELIER, sans regroupement : les pastilles-compteurs ont ete essayees puis
  retirees le 2026-09-23 (« je prefere individuel »). Le chevauchement en zone dense (Lyon,
  PACA) est assume : c'est lui qui donne a voir la densite du reseau.

  CONTROLES : aucun controle natif dans le conteneur `role="img"`. Deux vrais `<button>`
  (`data-gm-zoom-in`/`data-gm-zoom-out`, sections/garantie-mint.liquid) vivent HORS de ce
  conteneur. La molette et un balayage vertical appartiennent a la PAGE, pas a la carte.

  RECHERCHE : deux etages —
    1. le CP saisi correspond EXACTEMENT au CP d'un atelier -> il passe en tete ;
    2. sinon, distance haversine depuis le CENTRE DU CODE POSTAL (geo.api.gouv.fr, moyenne
       de ses communes ponderee par leur population). Le centre du departement, tire vers
       sa prefecture, classait Bordeaux devant Langon pour un CP du sud Gironde : il ne sert
       plus que de repli si l'API ne repond pas (table DEP, 96 entrees).
  Le kilometrage n'est PAS affiche : mesure le 2026-09-22, la distance depuis un centre
  departemental se trompe jusqu'a 11 km annonces pour 1 km reel (Lille). Le CLASSEMENT,
  lui, est bon (4 top-1 exacts sur 7 villes testees, et les 3 autres restent proches) —
  sans commune mesure avec le tri par NUMERO de departement de
  snippets/product-delivery-block.liquid:582-586, qui repond Mauguio (666 km) a « Rennes ».
  Departement INCONNU (ex. DOM-TOM, CP hors table) : aucun classement fiable n'est
  possible, on ne renvoie que les correspondances de CP exact — jamais une liste
  arbitraire prise dans l'ordre d'insertion.

  ETAT DEGRADE : zero atelier exploitable -> on masque le bloc entier plutot que de
  dessiner une France vide sous un titre qui annonce un reseau. Le garde-fou CSS
  `.garantie-mint[hidden]{display:none}` est indispensable (anti-patterns n°8 et n°20).

  TRACKING : les boutons de resultat portent `data-cta-name`, capte par le listener
  delegue de snippets/tracking-ecommerce.liquid. Aucun push depuis ce fichier : un second
  emetteur produirait un doublon invisible au grep (anti-pattern n°45).
*/
(function () {
  'use strict';

  if (window.__gmInit) return;
  window.__gmInit = true;

  var STYLE_URL = 'https://tiles.openfreemap.org/styles/positron';
  // Niveaux MapLibre = niveaux Leaflet - 1 a echelle egale (tuiles de 512px).
  var ZOOM_OFFSET = 1;

  var MAX_RESULTS = 3;
  var MIN_ZOOM = 4;
  var MAX_ZOOM = 14;
  // Zoom cible de `focusStore` (recherche par code postal) : l'echelle d'une agglomeration.
  var FOCUS_ZOOM = 9;
  // Cadrage d'ouverture : la France METROPOLITAINE continentale, pas l'enveloppe des
  // ateliers (qui ajoute la Corse et imposait un zoom plus large). [lng, lat] (MapLibre).
  var FRANCE_BOUNDS = [
    [-4.8, 42.6],
    [8.2, 51.05],
  ];

  // Repere « M » (demande du 2026-09-23 : « un truc qui fait reference a MINT, genre un M
  // vert », d'apres le badge de marque carre menthe au M noir) : carre arrondi menthe,
  // filet et M noirs, pointe centree en bas qui designe l'atelier. viewBox 32x38, la
  // pointe touche le bas (y = 29,5). Partage par les marqueurs de la carte et l'icone de
  // chaque resultat de recherche (memes classes CSS, cf. garantie-mint.css).
  // Badge PLUS LARGE QUE HAUT (29x21 hors pointe) : la premiere version, carree et
  // prolongee de sa pointe, se lisait « trop en long » (retour du 2026-09-23) ; le M est
  // elargi d'autant.
  var MARK_SVG_INNER =
    '<path class="gm-mark-body" d="M6.5 1.5h19a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-6.3L16 29.5l-3.2-7H6.5a5 5 0 0 1-5-5v-11a5 5 0 0 1 5-5z"/>' +
    '<path class="gm-mark-m" d="M8 17.5v-11h4.6L16 11.6l3.4-5.1H24v11h-3.6v-6.2L16 16.8l-4.4-6.5v7.2z"/>';
  var MARK_RATIO = 31 / 32;
  var RESULT_ICON_SVG = '<svg viewBox="0 0 32 31" width="20" height="19">' + MARK_SVG_INNER + '</svg>';

  // Centre de chaque departement, moyenne des communes ponderee par leur population
  // (source geo.api.gouv.fr, calcule une fois le 2026-09-22). 96 entrees, 1918 octets.
  var DEP = {
    '01': [46.108, 5.359],
    '02': [49.572, 3.458],
    '03': [46.335, 3.155],
    '04': [44.004, 6.017],
    '05': [44.617, 6.209],
    '06': [43.682, 7.16],
    '07': [44.809, 4.573],
    '08': [49.723, 4.71],
    '09': [43.021, 1.558],
    10: [48.314, 4.065],
    11: [43.175, 2.574],
    12: [44.319, 2.586],
    13: [43.408, 5.296],
    14: [49.159, -0.327],
    15: [45.007, 2.57],
    16: [45.691, 0.117],
    17: [45.904, -0.891],
    18: [47.084, 2.426],
    19: [45.266, 1.705],
    21: [47.311, 4.973],
    22: [48.516, -2.806],
    23: [46.134, 1.951],
    24: [45.075, 0.699],
    25: [47.255, 6.356],
    26: [44.823, 4.948],
    27: [49.135, 1.085],
    28: [48.474, 1.405],
    29: [48.266, -4.2],
    '2A': [41.859, 8.857],
    '2B': [42.528, 9.332],
    30: [43.932, 4.323],
    31: [43.553, 1.375],
    32: [43.693, 0.517],
    33: [44.84, -0.579],
    34: [43.546, 3.669],
    35: [48.175, -1.68],
    36: [46.788, 1.637],
    37: [47.34, 0.684],
    38: [45.348, 5.492],
    39: [46.774, 5.654],
    40: [43.825, -0.943],
    41: [47.58, 1.379],
    42: [45.603, 4.29],
    43: [45.162, 3.923],
    44: [47.272, -1.696],
    45: [47.915, 2.165],
    46: [44.626, 1.597],
    47: [44.345, 0.52],
    48: [44.557, 3.466],
    49: [47.376, -0.601],
    50: [49.17, -1.41],
    51: [49.101, 4.127],
    52: [48.217, 5.168],
    53: [48.107, -0.711],
    54: [48.84, 6.112],
    55: [48.974, 5.363],
    56: [47.763, -2.917],
    57: [49.155, 6.448],
    58: [47.089, 3.305],
    59: [50.555, 3.14],
    60: [49.359, 2.462],
    61: [48.616, 0.028],
    62: [50.535, 2.423],
    63: [45.772, 3.174],
    64: [43.361, -0.911],
    65: [43.178, 0.112],
    66: [42.657, 2.841],
    67: [48.618, 7.666],
    68: [47.839, 7.32],
    69: [45.774, 4.813],
    70: [47.633, 6.205],
    71: [46.629, 4.645],
    72: [47.984, 0.201],
    73: [45.578, 6.122],
    74: [46.065, 6.297],
    75: [48.859, 2.347],
    76: [49.547, 0.839],
    77: [48.722, 2.766],
    78: [48.871, 1.992],
    79: [46.528, -0.374],
    80: [49.941, 2.263],
    81: [43.776, 2.114],
    82: [44.038, 1.286],
    83: [43.281, 6.175],
    84: [43.994, 5.013],
    85: [46.698, -1.409],
    86: [46.615, 0.403],
    87: [45.856, 1.22],
    88: [48.188, 6.518],
    89: [47.938, 3.481],
    90: [47.627, 6.884],
    91: [48.638, 2.329],
    92: [48.856, 2.257],
    93: [48.91, 2.454],
    94: [48.795, 2.442],
    95: [49.016, 2.249],
  };

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // --- Horaires ---------------------------------------------------------------
  // Charges A LA DEMANDE, a la premiere recherche : ils vivent dans
  // sections/garantie-mint-horaires.liquid, rendue par la Section Rendering API (voir
  // l'en-tete de ce fichier Liquid pour le pourquoi). Promesse memorisee : une seule
  // requete par page, quel que soit le nombre de recherches.
  var DAY_KEYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var hoursPromise = null;

  function coordKey(la, lo) {
    return Number(la).toFixed(3) + ',' + Number(lo).toFixed(3);
  }

  function parseMaybeTwice(raw) {
    try {
      var once = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return typeof once === 'string' ? JSON.parse(once) : once;
    } catch (e) {
      return null;
    }
  }

  function loadHours() {
    if (hoursPromise) return hoursPromise;
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    hoursPromise = fetch(rootUrl + '?sections=garantie-mint-horaires', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (payload) {
        var html = payload && payload['garantie-mint-horaires'];
        var doc = new DOMParser().parseFromString(html || '', 'text/html');
        var node = doc.querySelector('[data-gm-hours]');
        var list = parseMaybeTwice(node ? node.textContent : '[]');
        var byCoord = {};
        (Array.isArray(list) ? list : []).forEach(function (st) {
          var h = parseMaybeTwice(st && st.horaires);
          if (h && typeof h === 'object') byCoord[coordKey(st.lat, st.long)] = h;
        });
        return byCoord;
      })
      .catch(function () {
        // Horaires indisponibles : les resultats restent affiches, sans cette ligne.
        return {};
      });
    return hoursPromise;
  }

  // « 09:00 » -> « 9h », « 14:30 » -> « 14h30 ».
  function formatTime(hhmm) {
    var m = /^(\d{1,2}):(\d{2})/.exec(String(hhmm || ''));
    if (!m) return '';
    return parseInt(m[1], 10) + 'h' + (m[2] === '00' ? '' : m[2]);
  }

  // Creneaux d'une journee, ou '' si fermee ou non renseignee.
  function formatDay(day) {
    if (!day || day.closed) return '';
    return (day.slots || [])
      .map(function (s) {
        var open = formatTime(s && s.open);
        var close = formatTime(s && s.close);
        return open && close ? open + '–' + close : '';
      })
      .filter(Boolean)
      .join(', ');
  }

  function parseStores(root) {
    var node = root.querySelector('[data-gm-stores]');
    if (!node) return [];
    var parsed;
    try {
      parsed = JSON.parse(node.textContent);
      // L'app republie parfois sa valeur double-encodee : une chaine JSON contenant du
      // JSON. Meme parade que snippets/product-delivery-block.liquid:550-557.
      if (typeof parsed === 'string') parsed = JSON.parse(parsed);
    } catch (e) {
      return [];
    }
    if (!Array.isArray(parsed)) return [];
    return parsed
      .map(function (s) {
        // `| json` serialise en chaine : on renormalise au parse, sinon toute comparaison
        // ou tout calcul sur `la`/`lo` est faux en silence (anti-pattern n°22).
        var la = Number(s.la !== undefined ? s.la : s.lat);
        var lo = Number(s.lo !== undefined ? s.lo : s.long);
        var z = String(s.z !== undefined ? s.z : s.zip || '').replace(/\D/g, '');
        return {
          name: s.n || s.name || '',
          city: s.c || s.city || '',
          address: s.a || s.address || '',
          zip: z.length >= 4 ? ('00000' + z).slice(-5) : '',
          la: la,
          lo: lo,
        };
      })
      .filter(function (s) {
        return (
          isFinite(s.la) &&
          isFinite(s.lo) &&
          s.la > 41.2 &&
          s.la < 51.5 &&
          s.lo > -5.5 &&
          s.lo < 9.8 &&
          (s.name || s.city)
        );
      });
  }

  function haversine(a, b) {
    var R = 6371;
    var p = Math.PI / 180;
    var dLa = (b[0] - a[0]) * p;
    var dLo = (b[1] - a[1]) * p;
    var h =
      Math.sin(dLa / 2) * Math.sin(dLa / 2) +
      Math.cos(a[0] * p) * Math.cos(b[0] * p) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  // 2A/2B : les CP corses commencent par 20, le departement ne s'en deduit pas. On tranche
  // sur la borne officielle 20000-20199 = Corse-du-Sud, au-dela = Haute-Corse.
  var GEO_API = 'https://geo.api.gouv.fr/communes?fields=centre,population&format=json&codePostal=';
  var GEO_TIMEOUT_MS = 2500;
  var zipCentres = {};

  // Centre du code postal : moyenne des communes qui le portent, ponderee par leur
  // population. Resout a null en cas d'echec, qui n'est pas mis en cache.
  function fetchZipCentre(zip) {
    if (zipCentres[zip]) return zipCentres[zip];
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, GEO_TIMEOUT_MS) : 0;
    zipCentres[zip] = fetch(GEO_API + zip, ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) {
        if (!r.ok) throw new Error('geo ' + r.status);
        return r.json();
      })
      .then(function (communes) {
        clearTimeout(timer);
        var la = 0;
        var lo = 0;
        var weight = 0;
        communes.forEach(function (c) {
          if (!c.centre) return;
          var w = Math.max(c.population || 0, 1);
          la += c.centre.coordinates[1] * w;
          lo += c.centre.coordinates[0] * w;
          weight += w;
        });
        if (!weight) throw new Error('geo vide');
        return [la / weight, lo / weight];
      })
      .catch(function () {
        clearTimeout(timer);
        delete zipCentres[zip];
        return null;
      });
    return zipCentres[zip];
  }

  function depOf(zip) {
    if (!/^\d{5}$/.test(zip)) return null;
    if (zip.slice(0, 2) === '20') {
      return parseInt(zip, 10) < 20200 ? '2A' : '2B';
    }
    return zip.slice(0, 2);
  }

  function loadOnce(url, kind) {
    var attr = kind === 'css' ? 'href' : 'src';
    var existing = document.querySelector('[data-gm-asset="' + kind + '"]');
    if (existing) return existing.__gmReady;
    var el = kind === 'css' ? document.createElement('link') : document.createElement('script');
    if (kind === 'css') {
      el.rel = 'stylesheet';
    }
    el.setAttribute('data-gm-asset', kind);
    el.__gmReady = new Promise(function (resolve, reject) {
      el.onload = resolve;
      el.onerror = reject;
    });
    el[attr] = url;
    document.head.appendChild(el);
    return el.__gmReady;
  }

  function setError(root, msg) {
    var el = root.querySelector('[data-gm-error]');
    if (!el) return;
    el.textContent = msg || '';
  }

  function renderResults(root, stores, exactZip, t) {
    var wrap = root.querySelector('[data-gm-results]');
    var ul = root.querySelector('[data-gm-results-list]');
    if (!wrap || !ul) return;
    ul.innerHTML = '';
    if (!stores.length) {
      wrap.hidden = true;
      return;
    }
    stores.forEach(function (s) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'garantie-mint__result';
      btn.setAttribute('data-cta-name', 'atelier_resultat');
      btn.setAttribute('data-cta-location', 'garantie_mint');
      btn.setAttribute('data-gm-lat', String(s.la));
      btn.setAttribute('data-gm-lon', String(s.lo));

      var icon = document.createElement('span');
      icon.className = 'garantie-mint__result-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = RESULT_ICON_SVG; // constante fixe, aucune donnee utilisateur
      btn.appendChild(icon);

      var body = document.createElement('span');
      body.className = 'garantie-mint__result-body';

      var top = document.createElement('span');
      top.className = 'garantie-mint__result-top';

      var name = document.createElement('span');
      name.className = 'garantie-mint__result-name';
      name.textContent = s.name || s.city;
      top.appendChild(name);

      if (exactZip && s.zip === exactZip) {
        var badge = document.createElement('span');
        badge.className = 'garantie-mint__result-badge';
        badge.textContent = t.inTown;
        top.appendChild(badge);
      }

      body.appendChild(top);

      if (s.city) {
        var city = document.createElement('span');
        city.className = 'garantie-mint__result-city';
        city.textContent = s.city;
        body.appendChild(city);
      }

      var addrLine = [s.address, s.zip].filter(Boolean).join(' · ');
      if (addrLine) {
        var addr = document.createElement('span');
        addr.className = 'garantie-mint__result-address';
        addr.textContent = addrLine;
        body.appendChild(addr);
      }

      // Rempli par `fillResultHours` une fois les horaires charges ; vide jusque-la.
      var hoursEl = document.createElement('span');
      hoursEl.className = 'garantie-mint__result-hours';
      hoursEl.setAttribute('data-gm-hours-for', coordKey(s.la, s.lo));
      body.appendChild(hoursEl);

      btn.appendChild(body);
      li.appendChild(btn);
      ul.appendChild(li);
    });
    wrap.hidden = false;
  }

  function weekdayLabel(key) {
    // 2024-01-07 est un dimanche : l'index de DAY_KEYS donne donc le bon jour.
    var idx = DAY_KEYS.indexOf(key);
    try {
      var lang = document.documentElement.lang || 'fr';
      var label = new Date(2024, 0, 7 + idx).toLocaleDateString(lang, { weekday: 'long' });
      return label.charAt(0).toUpperCase() + label.slice(1);
    } catch (e) {
      return key;
    }
  }

  function popupHtml(s, t) {
    var html =
      '<strong>' +
      escapeHtml(s.name || s.city) +
      '</strong>' +
      escapeHtml([s.address, s.zip, s.city].filter(Boolean).join(' · '));
    if (s.hours) {
      var today = DAY_KEYS[new Date().getDay()];
      // Semaine du lundi au dimanche, jour courant en gras.
      var rows = DAY_KEYS.slice(1)
        .concat(DAY_KEYS[0])
        .map(function (key) {
          var slots = formatDay(s.hours[key]) || t.closed;
          var cls = key === today ? ' class="is-today"' : '';
          return (
            '<li' +
            cls +
            '><span>' +
            escapeHtml(weekdayLabel(key)) +
            '</span><span>' +
            escapeHtml(slots) +
            '</span></li>'
          );
        })
        .join('');
      html += '<ul class="gm-popup-hours">' + rows + '</ul>';
    }
    return html;
  }

  /*
    COULEURS FACON GOOGLE MAPS appliquees au style « positron » d'OpenFreeMap : terres
    vert menthe, mer bleue franche, textes presque noirs. Memes cibles que le rendu
    precedent (mer 122,206,232 ; terres ~184,235,203), propres a cette carte : ce ne sont
    pas des tokens du design system.
  */
  var BRAND_PAINT = {
    background: { 'background-color': '#b8ebcb' },
    park: { 'fill-color': '#a8e3bf' },
    landcover_wood: { 'fill-color': '#9ad9b0' },
    landuse_residential: { 'fill-color': '#c6f0d6' },
    building: { 'fill-color': '#c6f0d6' },
    water: { 'fill-color': '#7acee8' },
    waterway: { 'line-color': '#7acee8' },
    boundary_2: { 'line-color': '#3a3a3a' },
    boundary_3: { 'line-color': '#8fb49f' },
    highway_motorway_subtle: { 'line-color': '#8fa8c2', 'line-width': 1.2 },
    highway_major_subtle: { 'line-color': '#a7bbd0', 'line-width': 0.8 },
    highway_motorway_inner: { 'line-color': '#a7bbd0' },
  };
  // Positron vide la carte a l'echelle du pays : on avance villes moyennes et forets,
  // qui n'apparaissent sinon qu'au niveau departement.
  var EARLY_LAYERS = {
    label_town: 5,
    landcover_wood: 5,
  };
  var LABEL_LAYERS = [
    'label_other',
    'label_village',
    'label_town',
    'label_state',
    'label_city',
    'label_city_capital',
    'label_country_3',
    'label_country_2',
    'label_country_1',
  ];

  function paintBrand(map) {
    Object.keys(BRAND_PAINT).forEach(function (id) {
      if (!map.getLayer(id)) return;
      var props = BRAND_PAINT[id];
      Object.keys(props).forEach(function (prop) {
        map.setPaintProperty(id, prop, props[prop]);
      });
    });
    // Noms de regions en petites capitales italiques grises : illisibles a cette taille.
    if (map.getLayer('label_state')) map.setLayoutProperty('label_state', 'visibility', 'none');
    Object.keys(EARLY_LAYERS).forEach(function (id) {
      if (!map.getLayer(id)) return;
      map.setLayerZoomRange(id, EARLY_LAYERS[id], 24);
    });
    LABEL_LAYERS.forEach(function (id) {
      if (!map.getLayer(id)) return;
      map.setPaintProperty(id, 'text-color', '#1a1a1a');
      map.setPaintProperty(id, 'text-halo-color', 'rgba(255, 255, 255, 0.85)');
      // Halo net : le flou d'origine de positron (1px) adoucit tout le contour des lettres.
      map.setPaintProperty(id, 'text-halo-blur', 0);
      map.setPaintProperty(id, 'text-halo-width', 1.2);
      // Noms en francais quand OSM les porte (« Londres », « Bruxelles »).
      map.setLayoutProperty(id, 'text-field', ['coalesce', ['get', 'name:fr'], ['get', 'name:latin'], ['get', 'name']]);
    });
  }

  // Petits a l'echelle du pays : 160 reperes individuels sur une France de ~550px se
  // chevaucheraient en tache a 30px. `zoom` en niveaux Leaflet (cf. ZOOM_OFFSET).
  function pinSizeForZoom(zoom) {
    // Zoom du cadre mobile (~5) : la France n'y fait que ~320px de large.
    if (zoom < 5.5) return 16;
    if (zoom <= 6.5) return 22;
    if (zoom <= 8) return 26;
    if (zoom <= 10) return 30;
    return 34;
  }

  function pinSvg(size) {
    var height = Math.round(size * MARK_RATIO);
    return '<svg viewBox="0 0 32 31" width="' + size + '" height="' + height + '">' + MARK_SVG_INNER + '</svg>';
  }

  // La pointe (bas du path) touche la coordonnee : le Marker est ancre en `bottom`.
  function pinElement(size) {
    var el = document.createElement('div');
    el.className = 'gm-pin';
    el.innerHTML = '<div class="gm-pin__svg">' + pinSvg(size) + '</div>'; // constante, aucune donnee
    return el;
  }

  function init(root) {
    if (root.__gmBound) return;
    root.__gmBound = true;

    var mapEl = root.querySelector('[data-gm-map]');
    var stores = parseStores(root);

    // Une France vide sous un titre qui annonce un reseau est pire que pas de carte.
    if (!stores.length) {
      root.hidden = true;
      return;
    }
    root.setAttribute('data-gm-count', String(stores.length));

    var t = {
      invalid: root.getAttribute('data-l-invalid') || '',
      none: root.getAttribute('data-l-none') || '',
      inTown: root.getAttribute('data-l-intown') || '',
      today: root.getAttribute('data-l-today') || '',
      closed: root.getAttribute('data-l-closed') || '',
    };

    // Accroche les horaires aux ateliers (pour les popups) et remplit la ligne
    // « Aujourd'hui » des resultats affiches.
    function fillResultHours() {
      loadHours().then(function (byCoord) {
        stores.forEach(function (s) {
          if (!s.hours) s.hours = byCoord[coordKey(s.la, s.lo)] || null;
        });
        var today = DAY_KEYS[new Date().getDay()];
        root.querySelectorAll('[data-gm-hours-for]').forEach(function (el) {
          var h = byCoord[el.getAttribute('data-gm-hours-for')];
          if (!h) return;
          var slots = formatDay(h[today]);
          el.textContent = t.today + ' : ' + (slots || t.closed);
          el.classList.toggle('is-closed', !slots);
        });
        // La popup ouverte a pu s'afficher AVANT l'arrivee des horaires.
        Object.keys(markers).forEach(function (key) {
          var popup = markers[key].getPopup();
          if (popup && popup.isOpen()) popup.setHTML(popupHtml(markers[key].__gmStore, t));
        });
      });
    }

    var map = null;
    var markers = {};
    var pendingFocusKey = null;
    var currentPinSize = 0;

    function leafletZoom() {
      return map.getZoom() + ZOOM_OFFSET;
    }

    function syncZoomButtons() {
      var inBtn = root.querySelector('[data-gm-zoom-in]');
      var outBtn = root.querySelector('[data-gm-zoom-out]');
      if (!inBtn || !outBtn) return;
      inBtn.disabled = map.getZoom() >= map.getMaxZoom() - 0.01;
      outBtn.disabled = map.getZoom() <= map.getMinZoom() + 0.01;
    }

    function closePopups() {
      Object.keys(markers).forEach(function (key) {
        var popup = markers[key].getPopup();
        if (popup && popup.isOpen()) popup.remove();
      });
    }

    function createMarkers() {
      currentPinSize = pinSizeForZoom(leafletZoom());
      stores.forEach(function (s) {
        var popup = new window.maplibregl.Popup({ offset: 10, maxWidth: '280px', focusAfterOpen: false });
        // Contenu recalcule a l'OUVERTURE : les horaires arrivent apres la creation des
        // reperes. Clic direct sans recherche : `fillResultHours` les charge (une fois)
        // puis rafraichit la popup ouverte.
        popup.on('open', function () {
          popup.setHTML(popupHtml(s, t));
          fillResultHours();
        });
        popup.setHTML(popupHtml(s, t));
        var m = new window.maplibregl.Marker({ element: pinElement(currentPinSize), anchor: 'bottom' })
          .setLngLat([s.lo, s.la])
          .setPopup(popup)
          .addTo(map);
        m.__gmStore = s;
        markers[s.la + ',' + s.lo] = m;
      });
    }

    // Taille des reperes selon le zoom : on ne remplace que le SVG, les Marker restent.
    function resizeMarkers() {
      var size = pinSizeForZoom(leafletZoom());
      if (size !== currentPinSize) {
        currentPinSize = size;
        Object.keys(markers).forEach(function (key) {
          var holder = markers[key].getElement().querySelector('.gm-pin__svg');
          if (holder) holder.innerHTML = pinSvg(size);
        });
      }
      syncZoomButtons();
    }

    function openPendingPopup() {
      var m = pendingFocusKey && markers[pendingFocusKey];
      pendingFocusKey = null;
      if (!m) return;
      closePopups();
      m.togglePopup();
    }

    function focusStore(la, lo) {
      if (!map) return;
      pendingFocusKey = la + ',' + lo;
      // Centrer sur le CADRE mettrait l'atelier trouve sous le panneau de recherche, qui
      // couvre le bord gauche de la carte : le `padding` gauche decale le centre vise.
      var inset = panelInset();
      map.once('moveend', openPendingPopup);
      map.easeTo({
        center: [lo, la],
        zoom: FOCUS_ZOOM - ZOOM_OFFSET,
        padding: { top: 0, bottom: 0, left: inset, right: 0 },
        duration: 600,
      });
    }

    var searchToken = 0;

    function search() {
      var input = root.querySelector('[data-gm-zip]');
      if (!input) return;
      var zip = (input.value || '').replace(/\D/g, '');
      if (zip.length !== 5) zip = '';
      if (!zip) {
        input.setAttribute('aria-invalid', 'true');
        setError(root, t.invalid);
        renderResults(root, [], '', t);
        return;
      }
      input.removeAttribute('aria-invalid');

      var exact = stores.filter(function (s) {
        return s.zip === zip;
      });
      var dep = depOf(zip);
      var token = ++searchToken;
      // Hors metropole (DEP inconnu), on ne classe pas meme si l'API connait le CP.
      if (!dep || !DEP[dep]) {
        showResults(zip, exact, null);
        return;
      }
      fetchZipCentre(zip).then(function (centre) {
        if (token !== searchToken) return;
        showResults(zip, exact, centre || DEP[dep]);
      });
    }

    function showResults(zip, exact, origin) {
      var out;

      if (origin) {
        var ranked = stores.slice().sort(function (a, b) {
          return haversine(origin, [a.la, a.lo]) - haversine(origin, [b.la, b.lo]);
        });
        out = exact.slice();
        ranked.forEach(function (s) {
          if (out.length >= MAX_RESULTS) return;
          if (out.indexOf(s) === -1) out.push(s);
        });
        out = out.slice(0, MAX_RESULTS);
      } else {
        // Departement inconnu (ex. DOM-TOM) : aucun classement fiable possible, on ne
        // renvoie que les correspondances de CP exact, jamais une liste arbitraire.
        out = exact.slice(0, MAX_RESULTS);
      }

      setError(root, out.length ? '' : t.none);
      renderResults(root, out, exact.length ? zip : '', t);
      if (out.length) {
        fillResultHours();
        focusStore(out[0].la, out[0].lo);
      }
    }

    // Le tracking passe par le listener delegue de tracking-ecommerce.liquid : ce
    // handler-ci ne fait QUE piloter la carte (recherche, focus, zoom).
    root.addEventListener('click', function (e) {
      var searchBtn = e.target.closest('[data-gm-search]');
      if (searchBtn) {
        search();
        return;
      }
      if (e.target.closest('[data-gm-clear]')) {
        clearSearch();
        return;
      }
      var res = e.target.closest('[data-gm-lat]');
      if (res) {
        focusStore(Number(res.getAttribute('data-gm-lat')), Number(res.getAttribute('data-gm-lon')));
        return;
      }
      var zoomIn = e.target.closest('[data-gm-zoom-in]');
      if (zoomIn) {
        if (map) map.zoomIn();
        return;
      }
      var zoomOut = e.target.closest('[data-gm-zoom-out]');
      if (zoomOut) {
        if (map) map.zoomOut();
      }
    });

    function syncClearButton() {
      var input = root.querySelector('[data-gm-zip]');
      var clearBtn = root.querySelector('[data-gm-clear]');
      if (!input || !clearBtn) return;
      clearBtn.hidden = !input.value;
    }

    // Croix d'effacement : vide le champ, efface l'erreur, ferme la liste puis recadre la
    // carte sur la France — `fitAll` lit la hauteur du panneau, donc APRES la fermeture.
    function clearSearch() {
      var input = root.querySelector('[data-gm-zip]');
      if (!input) return;
      input.value = '';
      input.removeAttribute('aria-invalid');
      setError(root, '');
      renderResults(root, [], '', t);
      syncClearButton();
      if (map) {
        closePopups();
        fitAll();
      }
      input.focus();
    }

    root.addEventListener('input', function (e) {
      if (e.target.closest('[data-gm-zip]')) syncClearButton();
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      if (!e.target.closest('[data-gm-zip]')) return;
      e.preventDefault();
      search();
    });

    if (!mapEl) return;

    // Cadrage sur la surface REELLEMENT visible de la carte. Le panneau de recherche est
    // pose sur son bord gauche a partir de 769px : sans le retrancher, `fitBounds` centre
    // la France sur le cadre entier, donc la moitie ouest du pays passe sous le panneau et
    // le cadre se remplit de pays voisins a droite. On lit la position calculee du panneau
    // plutot qu'on ne rejoue le point de rupture en JS — une seule verite, celle du CSS.
    function panelInset() {
      var panel = root.querySelector('.garantie-mint__panel');
      if (!panel || window.getComputedStyle(panel).position !== 'absolute') return 0;
      return Math.round(panel.getBoundingClientRect().right - mapEl.getBoundingClientRect().left);
    }

    function fitAll() {
      if (!map) return;
      // `map_zoom` (reglage schema, niveaux Leaflet) plafonne le cadrage plutot que de le
      // fixer : un zoom fixe ne peut pas convenir au cadre large desktop et etroit mobile.
      var maxZoomSetting = parseInt(mapEl.getAttribute('data-gm-zoom'), 10) || 6;
      // Au repos, le panneau n'est qu'une pilule de 52px en haut a gauche : on ne lui
      // reserve sa largeur que lorsqu'il deroule la liste des ateliers.
      var inset = panelInset();
      var panel = root.querySelector('.garantie-mint__panel');
      var reserve = inset && panel && panel.getBoundingClientRect().height > 120 ? inset : 0;
      map.fitBounds(FRANCE_BOUNDS, {
        padding: { top: 8, bottom: 8, left: reserve ? reserve + 16 : 16, right: 16 },
        maxZoom: maxZoomSetting - ZOOM_OFFSET,
        animate: false,
      });
    }

    function buildMap() {
      if (map || typeof window.maplibregl === 'undefined') return;
      var isTouch = window.matchMedia('(pointer: coarse)').matches;
      map = new window.maplibregl.Map({
        container: mapEl,
        style: STYLE_URL,
        bounds: FRANCE_BOUNDS,
        minZoom: MIN_ZOOM - ZOOM_OFFSET,
        maxZoom: MAX_ZOOM - ZOOM_OFFSET,
        // L'attribution est rendue en Liquid (p.garantie-mint__attribution) pour rester
        // visible meme si la carte ne se charge pas.
        attributionControl: false,
        // Carte a plat : ni rotation ni inclinaison, qui n'apportent rien ici.
        dragRotate: false,
        pitchWithRotate: false,
        touchPitch: false,
        // Le scroll de la molette appartient a la PAGE : un clic DANS la carte l'active,
        // sortir du cadre le desactive (cf. plus bas).
        scrollZoom: false,
        // Un balayage vertical qui COMMENCE sur la carte (pleine largeur en mobile) doit
        // faire defiler la page ; le pincement reste disponible pour zoomer.
        dragPan: !isTouch,
      });
      map.touchZoomRotate.disableRotation();

      map.on('style.load', function () {
        paintBrand(map);
      });

      fitAll();
      createMarkers();
      map.on('zoom', resizeMarkers);
      syncZoomButtons();

      map.on('click', function () {
        map.scrollZoom.enable();
      });
      mapEl.addEventListener('mouseleave', function () {
        map.scrollZoom.disable();
      });

      // Seul un changement de LARGEUR recadre : sur mobile, la barre d'adresse qui se replie
      // au defilement declenche un `resize` en hauteur seule, qui ramenait la carte sur la
      // France entiere en plein affichage d'un atelier trouve. Le panneau passe aussi
      // d'absolu a statique sous 769px : la surface visible change de forme.
      var resizeTimer = null;
      var lastWidth = window.innerWidth;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          map.resize();
          if (window.innerWidth === lastWidth) return;
          lastWidth = window.innerWidth;
          fitAll();
        }, 200);
      });
    }

    function loadMap() {
      var css = mapEl.getAttribute('data-gm-map-css');
      var js = mapEl.getAttribute('data-gm-map-js');
      // Les DEUX ressources avant `buildMap` : sans le CSS de MapLibre, le canvas et les
      // marqueurs se construisent dans le flux normal — course gagnee ou perdue selon le
      // cache, invisible en recette.
      Promise.all([loadOnce(css, 'css'), loadOnce(js, 'js')])
        .then(buildMap)
        .catch(function () {
          // MapLibre indisponible : on garde le bloc et sa recherche, on masque la boite
          // de carte (et ses boutons de zoom, orphelins sans elle).
          mapEl.hidden = true;
          var zoomWrap = root.querySelector('.garantie-mint__zoom');
          if (zoomWrap) zoomWrap.hidden = true;
        });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.disconnect();
            loadMap();
          });
        },
        { rootMargin: '200px' },
      );
      io.observe(mapEl);
    } else {
      loadMap();
    }
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-gm-root]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // L'editeur re-rend le HTML sans rejouer le JS de chargement de page.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('[data-gm-root]')) boot(e.target);
  });
})();
